// extracted by mini-css-extract-plugin
export default {"container":"Header_container__gVk2h","menuItem":"Header_menuItem__7Y6rD"};